import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles'

function BuildComplianceList(props) {
  const { listType } = props

  const classes = styles()

  return (
    <div className={classes.root}>
      <h3>Assessor(a) consta na Compliance List</h3>
      <p>
        Essa pessoa se encontra na {`"${listType}"`}. Consulte a lista e{' '}
        entenda os riscos antes de aprovar ou reprovar. Considere encaminhar para{' '}
        seu superior imediato em caso de dúvida.
      </p>
    </div>
  )
}

BuildComplianceList.propTypes = {
  listType: PropTypes.string.isRequired,
}

export default BuildComplianceList
